import { Component, OnInit, Inject } from '@angular/core';
import { LogWsService } from 'src/app/servicios/log-ws.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog-web-service',
  templateUrl: './dialog-web-service.component.html',
  styleUrls: ['./dialog-web-service.component.css']
})
export class DialogWebServiceComponent implements OnInit {

  detalleLogWS=[];
  idTipoWS:any;
  idPaquete:any;
  red:any;
  green:any;
  dataModified = false;



  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private servicioLogWS:LogWsService,
    private sanitizer: DomSanitizer
  ) {
    this.red = this.sanitizer.bypassSecurityTrustStyle('#FF0000');
    this.green = this.sanitizer.bypassSecurityTrustStyle('#008000');
    this.idTipoWS=dataDialog.idTipoWS;
    this.idPaquete=dataDialog.idPaquete;
    console.log(dataDialog);
    this.servicioLogWS.getDetalleWS(this.idTipoWS, this.idPaquete)
    .subscribe(result=>{
      this.detalleLogWS=result;
      this.detalleLogWS.forEach((element, indice)=>{
        this.detalleLogWS[indice].fecha = new Date(element.fecha);
      });
      console.log(this.detalleLogWS);
    });
   }

  ngOnInit() {
  }

}
